import { type PropsWithChildren } from 'react'
import { AutomaticField } from '@/components/PriceCalculator/AutomaticField'
import { type InputField } from '@/services/PriceCalculator/Field.types'
import type { SectionItem } from '@/services/PriceCalculator/PriceCalculator.types'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { yStack } from 'ui/src/patterns/stack'
import { columnSpan, grid, gridItem } from './FormGridNew.css'

type FormSectionProps = PropsWithChildren<{
  items: Array<SectionItem>
  autofocusFirst?: boolean
}>

export function FormGridNew({ items, autofocusFirst, children }: FormSectionProps) {
  return (
    <div className={yStack({ gap: { _: 'md', lg: 'lg' } })}>
      <div className={grid}>
        {items.map((item, index) => (
          <div
            className={gridItem}
            key={fieldKey(item.field)}
            style={assignInlineVars({
              [columnSpan]: `${item.layout.columnSpan}`,
            })}
          >
            <AutomaticField field={item.field} autoFocus={autofocusFirst && index === 0} />
          </div>
        ))}
      </div>

      {children}
    </div>
  )
}

// GOTCHA: Uncontrolled fields keep very first defaultValue they had
// Therefore, we want to remount the field when defaultValue changes.
const fieldKey = (field: InputField): string => {
  const defaultValue = field.defaultValue ? JSON.stringify(field.defaultValue) : ''
  return `${field.name}_${defaultValue}`
}
